// extracted by mini-css-extract-plugin
export default {"gameEnvSelector":"GameEnvironmentSelector_gameEnvSelector__0zQ3J"};